import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const uploadFiles = async (files, prefix = '') => {
  const formData = new FormData();
  
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  
  if (prefix) {
    formData.append('prefix', prefix);
  }

  const response = await axios.post(`${API_BASE_URL}/admin/files/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.urls;
};

export const uploadFileWithName = async (file, fileName) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileName', fileName);

  const response = await axios.post(`${API_BASE_URL}/admin/files/upload-named`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.url;
};

export const listFiles = async (prefix = '') => {
  const response = await axios.get(`${API_BASE_URL}/admin/files/list`, {
    params: { prefix },
  });

  return response.data.files;
};

export const deleteFile = async (blobName) => {
  await axios.delete(`${API_BASE_URL}/admin/files/${encodeURIComponent(blobName)}`);
};
